module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ts-grid",
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "ts-grid--footer"
  }, [_vm._t("footer")], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-38858ccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/card/tsGridItem.vue
// module id = 821
// module chunks = 39